import { useEffect, useState } from "react";

export default function AnfitriaoFinanceiroExtrato() {
  const [movs, setMovs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function carregar() {
      try {
        const response = await fetch("/anfitriao/financeiro/extrato/dados", {
          credentials: "include",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        setMovs(Array.isArray(data.data) ? data.data : []);
      } catch (error) {
        console.error("Erro ao carregar extrato:", error);
      } finally {
        setLoading(false);
      }
    }

    carregar();
  }, []);

  return (
    <div className="min-h-screen bg-muted/30 p-6">
      <div className="mx-auto max-w-5xl">
        <h1 className="mb-6 text-2xl font-800">Extrato Financeiro</h1>

        {loading ? (
          <div>Carregando...</div>
        ) : movs.length === 0 ? (
          <div>Nenhuma movimentação encontrada.</div>
        ) : (
          <div className="space-y-3">
            {movs.map((m) => (
              <div key={m.id} className="rounded-xl border bg-white p-4">
                <div><strong>Descrição:</strong> {m.descricao}</div>
                <div><strong>Tipo:</strong> {m.tipo}</div>
                <div><strong>Status:</strong> {m.status}</div>
                <div><strong>Valor:</strong> {(Number(m.valor_cents || 0) / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}